import ModalFiltro from '../../../../components/modalFiltros';
import { SelectCelula } from '../../../../components/selects/celula';
import { SelectMinisterio } from '../../../../components/selects/ministerio';
import { SelectSede } from '../../../../components/selects/sede';
import { UseListMembros } from '../context/ListMembros';
import { Button, Grid } from '@mui/material';

export default function PopUpFiltroListaMembros() {


  const { alterParams, refetch, reset, params } = UseListMembros()

  const getSede = (value: string) => alterParams('sede', value);

  const getMinisterio = (value: any) => alterParams('ministerio', value?.target?.value)

  const getCelula = (value: any) => alterParams('celula', value?.target?.value)

  return (
    <>
      <ModalFiltro>
        <div onClick={(e) => e.stopPropagation()}>
          <section style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5, height: 50, borderBottom: '1px solid #ccc' }}>
            <h2>Filtros</h2>
          </section>

          <Grid>
              <SelectSede
                action={getSede}
                value={params?.sede}
              />
              <SelectMinisterio
                action={getMinisterio}
                idsede={params?.sede}
                valor={params?.ministerio}
              />
              <SelectCelula
                action={getCelula}
                idministerio={params?.ministerio}
                valor={params?.celula}
              />
          </Grid>

          <section>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginTop: 2 }}>
              <Button
                color='error'
                onClick={reset}
              >
                Limpar
              </Button>
              <Button
                variant='contained'
                sx={{
                  boxShadow: 'none'
                }}
                onClick={refetch}
              >
                Enviar
              </Button>
            </div>
          </section>
        </div>
      </ModalFiltro>
    </>
  )
}
